<template lang="pug">
.info-banner.dismissible(@click="$router.push('/settings/marketing')")
    span.icon ⚠️
    span.text-banner-info {{ text }}
    button.close-button(type="button" @click.stop="dismiss") ×
</template>
<script>
export default {
  name: 'InfoBannerDismissible',
  props: {
    text: String,
  },
  methods: {
    dismiss() {
      this.$store.dispatch('userdata/dismissMarketingWarning');
    }
  }
};
</script>
<style lang="scss" scoped>
// Reuse InfoBanner styles and add close button styling
.info-banner.dismissible {
  display: flex;
  align-items: center;
  background-color: $danger;
  color: white;
  padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
    cursor: pointer;
}
.info-banner.dismissible .close-button {
  margin-left: auto;
  background-color: $danger;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 0 5px;
}
</style>